import { exposeToWindow } from 'dgad-base/lib/modules/dgad-utils/src/utils'
import DTMHandler from './adobe/DTMHandler.class'
import DTMRule from './adobe/DTMRule.class'

exposeToWindow('DTMHandler', DTMHandler, { replace: true })
exposeToWindow('DTMRule', DTMRule, { replace: true })



// WEBPACK FOOTER //
// ./lib/modules/dgad-analytics/src/entry-client-analytics.js